// Widget: Meine Projekte — alle aktiven Projekte als kompakte Card-Liste.

import { useProjects } from "../../store/projects";
import { useUserPrefs } from "../../store/userPrefs";
import { useMe } from "../../lib/auth";
import { isProjectVisible } from "../../lib/departmentFilter";
import { ProjectCard } from "../ProjectCard";

export function MyProjectsWidget(): preact.JSX.Element {
  const projects = useProjects();
  const prefs = useUserPrefs();
  const me = useMe();

  if (projects.loading)
    return <p class="text-xs text-[color:var(--color-on-surface-variant)] italic">Lädt…</p>;

  // „Meine Projekte" = aktive Projekte im Department-Filter-Scope, in denen ich
  // entweder Owner bin oder als Assignee in mindestens einer Task stehe.
  // Approximation: filter auf active + visible.
  const visible = projects.items.filter(
    (p) =>
      isProjectVisible(p, prefs.visible_departments) &&
      p.status === "active" &&
      (me.user?.id === undefined || true) // (Voll-Mitgliedschaft kommt mit Permissions-Story)
  );

  if (visible.length === 0)
    return (
      <p class="text-xs text-[color:var(--color-on-surface-variant)] italic">
        Keine aktiven Projekte.
      </p>
    );

  return (
    // `auto-fit` statt fixer Spaltenzahl: bei 1-2 Karten in einer volle-Breite-
    // Kachel liess `grid-cols-3` die ungenutzten Spalten leer stehen (sichtbare
    // Luecke bei breiten Fenstern). `auto-fit` kollabiert leere Spalten und
    // verteilt die frei werdende Breite auf die vorhandenen Karten (`1fr`) —
    // bei vielen Karten bleibt das Verhalten wie vorher (Umbruch bei <240px).
    <div class="grid gap-3 [grid-template-columns:repeat(auto-fit,minmax(240px,1fr))]">
      {visible.slice(0, 6).map((p) => (
        <ProjectCard key={p.id} project={p} />
      ))}
    </div>
  );
}
